import { path } from '../utils';
import { User } from '../tools';

/**
* The properties from the View component combine,
* with the default properties.
*
* @function
* @param {Object} props All parameters to be used in the function
* @param {Object=} props.data The data object to be used in the request to be sent
* @param {function=} props.dispatch Redux dispatcher
* @param {function=} props.error Failed callback function
* @param {function=} props.success Successful callback function
* @return {Object}
*/

export const assign = (props) => {
  const object = Object.assign({}, {
    data: {},
    dispatch: undefined,
    error: () => true,
    success: () => true,
  }, props);

  return object;
};

/**
* Create a standard in-demand **fetch** function options
*
* @function
* @param {Object} body All data to be transmitted to the server
* @param {boolean} hasToken Checks that the **Token** value is added to the data
* @return {Object}
*/

export const options = (body = {}, hasToken = true) => {
  const data = body;

  if (!data.Token && hasToken) {
    data.Token = User.getToken() || 0;
  }

  return {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };
};

/**
 * Checks the token value returned from the service.
 *
 * It acts according to the incoming value.
 *
 * @param {string} token Return coin value from service
 */

export const check = (token) => {
  const account = User.getUserInfo();

  if (account) {
    if (token) {
      User.setToken(token);
    } else {
      User.setToken(0);
      window.location.href = path.app('/account/login?redirect=token');
    }
  }
};

/**
 * Combines with the values in the configuration
 * file of the given service endpoint.
 *
 * If you are working in a developer environment,
 * it uses **beta** service paths.
 *
 * @param {string} url Service name
 * @param {string} [type=] Key to be used in the configuration file
 * @return {string}
 */

export const endpoint = (url, type = 'origin') => (
  window.config.server[type] + url
);

export const convert = message => ([{
  description: message,
}]);
